import type { AbsoluteArray } from "../types.ts";
import { isPathArray } from "./isPathArray.ts";

/**
 * Iterates an array to check if it's a `pathArray`
 * with all absolute values.
 *
 * @param path the `pathArray` to be checked
 * @returns iteration result
 */
export const isAbsoluteArray = (path: unknown): path is AbsoluteArray => {
  return (
    isPathArray(path) &&
    // `isPathArray` also checks if it's `Array`
    path.every(([x]) => x === x.toUpperCase())
  );
};
